import React from 'react';
import { Typography, Button, Iconography } from '@lucid/lego';
import { useStore } from '../../store/store';
import styles from './NotFound.module.scss';

const NotFound: React.FC = () => {
  const locale = useStore((state) => state.locale);

  const handleGoHome = () => {
    const homeUrl = locale === 'en-us' ? '/' : `/${locale}/`;
    window.location.href = homeUrl;
  };

  return (
    <div className={styles.notFound}>
      <div className={styles.logo}>
        <div className={styles.logoGroup}>
          <Iconography category="brand" name="logo" color="white" size={32} />
          <Iconography category="brand" name="bear" color="white" size={32} />
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.notFoundBox}>
          <div className={styles.title}>
            <Typography variant="headline" size="medium" color="white">
              Page Not Found
            </Typography>
          </div>

          <div className={styles.subtitle}>
            <Typography variant="subtitle" size="small" color="gray-2">
              The page you are looking for doesn&apos;t exist or has been moved.
            </Typography>
          </div>

          <Button
            type="primary"
            label="Go to Dashboard"
            isFluid
            gaComponent="404-go-home"
            dataTestId="go-home-button"
            handleClick={handleGoHome}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
